import { useStore } from 'src/contexts/StoreContext';
import { EditLookupToolbarProps } from '../EditLookupToolbar.types';
import { useMemo } from 'react';
import { ProductOptionModel } from 'src/store/_models/productOption';
import { EDIT_TOOLS } from '../../base-toolbar/BaseToolbar.constants';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import amplitude from 'src/_shared/amplitude';
import { getAvailableEditTool } from '../EditLookupToolbar.constants';
import { ProductOptionChoiceModel } from 'src/store/_models/productOptionChoice';
import { Orientation } from '@photosi/expo-photosi-sdk/build/UserImage';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { parseAnalyticsParamsByUserImageArea } from 'src/_shared/analytics.utils';
import { ACTIVE_TOOLS } from 'src/store/page-project/pageProject.constants';

export const useOrientationToolLogic = ({ onOpenTool, onCloseTool }: EditLookupToolbarProps) => {
  const {
    project: { activeUserImageArea, setActiveTool },
  } = useStore();

  const { isDesktop } = useResponsiveScreen();

  const selectedOrientation = activeUserImageArea?.userImage?.orientation?.toLowerCase();

  return useMemo(
    () => ({
      tool: ProductOptionModel.create({
        code: EDIT_TOOLS.orientation,
        choices: [Orientation.VERTICAL, Orientation.HORIZONTAL].map(orientationUppercase => {
          const orientation = orientationUppercase.toLowerCase();
          return ProductOptionChoiceModel.create({
            productFamily: activeUserImageArea?.product?.family ?? '',
            productOptionCode: EDIT_TOOLS.orientation,
            productOptionChoiceCode: orientation,
            enabled: true,
            selected: selectedOrientation === orientation,
            isCustom: false,
            productConfigurationIdsMap: {
              [activeUserImageArea!.productId]: orientation,
            },
          });
        }),
      }),
      onOpenTool: async () => {
        const newOrientation =
          selectedOrientation?.toUpperCase() === Orientation.HORIZONTAL ? Orientation.VERTICAL : Orientation.HORIZONTAL;
        if (isDesktop) {
          await activeUserImageArea?.userImage?.applyOrientation(newOrientation);
        } else {
          setActiveTool(ACTIVE_TOOLS.orientation);
        }
        amplitude.trackEvent(AnalyticsEvents.modifyPhoto.orientationOptionClick, {
          ...parseAnalyticsParamsByUserImageArea(activeUserImageArea),
          orientation: newOrientation,
        });
        return {
          canBeSelected: false,
        };
      },
      onCloseTool,
      ToolOptionsRenderer: getAvailableEditTool(EDIT_TOOLS.orientation)?.ToolOptionsRenderer,
    }),
    [onOpenTool, onCloseTool, selectedOrientation, activeUserImageArea],
  );
};
